function Content(props) {
  return (
    <main className="flex-shrink-0 bg-light">
      {props.children}
    </main>
  );
}

export default Content;
